import { DEFAULT_QUERY_OPTIONS, useInfiniteQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys/glossary';

import {
  getGlossaryCategoryApi,
  type GetGlossaryCategoryResponse,
} from '@/features/glossary/api/getGlossaryCategoryListApi';

type UseGlossaryCategoryParams = {
  limit?: number;
};

export const useGlossaryCategory = ({ limit = 1000 }: UseGlossaryCategoryParams) => {
  return useInfiniteQueryWithBoundary({
    queryKey: glossaryKeys.categories(limit),
    queryFn: async (): Promise<GetGlossaryCategoryResponse> => {
      return getGlossaryCategoryApi({
        limit,
      });
    },
    getNextPageParam: (lastPage: GetGlossaryCategoryResponse) => lastPage.paging.after,
    initialPageParam: '',
    select: (data: { pages: GetGlossaryCategoryResponse[] }) => {
      return data.pages.flatMap((page: GetGlossaryCategoryResponse) => page.data);
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
